// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3RgCu","inputDescription":"styles_inputDescription__1TRBH"};